import { FaCamera, FaNetworkWired, FaSatelliteDish, FaTools } from "react-icons/fa";
import { MdMonitor } from "react-icons/md";

export const services = [
    {
        title: "Internet Satelital",
        icon: <FaSatelliteDish size={28} />,
    },
    {
        title: "Instalación de Cámaras",
        icon: <FaCamera size={28} />,
    },
    {
        title: "Mantenimiento Técnico",
        icon: <FaTools size={28} />,
    },
    {
        title: "Accesorios",
        icon: <FaTools size={28} />,
    },
    {
        title: "Instalación de Redes",
        icon: <FaNetworkWired size={28} />,
    },
    {
        title: "Salas de Monitoreo",
        icon: <MdMonitor size={28} />,
    },
];
